import React from 'react';
import BaseLoginRedirectPage from './BaseLoginRedirectPage';
import propTypes from 'prop-types';
import { routes } from 'app/constants';

export default function OrgSwitchRedirect(props) {
  const searchParams = new URLSearchParams(props.location.search);
  return <BaseLoginRedirectPage {...props} redirectTo={searchParams.get('redirect') ?? routes.home} />;
}

OrgSwitchRedirect.propTypes = {
  location: propTypes.shape({
    search: propTypes.string.isRequired,
  }).isRequired,
};
